import './../Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Plot from "react-plotly.js";
import { CoordinateConverter } from '../../../../util/coordinateConverter';

interface Props {
    index: number;
}

export default function PSD(props: Props) {
    const converter = new CoordinateConverter();
   
    const colorGray = 'rgba(140,140,140,1)';
    const colorWhite = 'rgba(255,255,255,1)';
    const colorYellow = 'rgba(255,255,140,1)';
    const colorRed = 'rgba(255,140,140,1)';
    
    let layout_psd_init = {
        height: 200,
        title: {
            text: 'PSD',
            font: {
                color: 'white',
                size: 12
            }
        },
        margin: {
            l: 50,
            r: 30,
            b: 40,
            t: 30,
            pad: 0
        },
        showlegend: true,
        legend: {
            font: {color: 'white'}
        },
        xaxis: {
            title: {
                text: 'Frequency (MHz)',
                font: {
                    color: 'white'
                }
            },
            dtick:2,
            autorange: true,
            tickcolor: 'white',
            tickfont: {
                color: 'white'
            },
            gridcolor: "rgb(110, 110, 50)",
            mirror: true,
            linewidth: 1,
            linecolor: "rgb(255, 255, 140)"
        },
        yaxis : {
            title: {
                text: 'Power (dB)',        
                font: {
                    color: 'white'
                }
            },        
            range:  [-120,-50],
            dtick:10,
            autorange: true,
            tickcolor: 'white',
            tickfont: {
                color: 'white'
            },
            gridcolor: "rgb(110, 110, 50)",
            mirror: true,
            linewidth: 1,
            linecolor: "rgb(255, 255, 140)"
        },
        plot_bgcolor :"black",
        paper_bgcolor:"black"
    }
    const [layout_psd, setPSDLayout] = useState(layout_psd_init);
    let psd_init = [{
        x: [-15,15],
        y: [-120,-120],
        mode: 'lines',
        name: 'L1',
        line: {color: colorWhite}
    },{
        x: [-15,15],
        y: [-120,-120],
        mode: 'lines',
        name: 'L2',
        line: {color: colorYellow}
    }];
    const [data_psd, setPSDData] = useState(psd_init);
    
    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const Status = layerData.status.GristStatus;
          
    useEffect(() => {
        if((props.index >= 0) && (props.index < Status.length)) {
            var localTime = new Date(Status[props.index].PSD.Time);
            var psd = [{
                x: [-15,15],
                y: [-120,-120],
                mode: 'lines',
                name: 'L1',
                line: {color: colorWhite}
            },{
                x: [-15,15],
                y: [-120,-120],
                mode: 'lines',
                name: 'L2',
                line: {color: colorYellow}
            }];
            if(Status[props.index].PSD.Array.length > 0) {
                psd[0].x = converter.getSeriesByLength(Status[props.index].PSD.Array[0].Freq[0], Status[props.index].PSD.Array[0].Freq[Status[props.index].PSD.Array[0].Freq.length - 1], Status[props.index].PSD.Array[0].Power.length);
                psd[0].y = Status[props.index].PSD.Array[0].Power;
            }
            if(Status[props.index].PSD.Array.length > 1) {
                psd[1].x = converter.getSeriesByLength(Status[props.index].PSD.Array[1].Freq[0], Status[props.index].PSD.Array[1].Freq[Status[props.index].PSD.Array[1].Freq.length - 1], Status[props.index].PSD.Array[1].Power.length);
                psd[1].y = Status[props.index].PSD.Array[1].Power;
            }
            setPSDData(psd);  
            let psdLayout = layout_psd;
            psdLayout.title.text = Status[props.index].Name + ' PSD ' + localTime.toLocaleString();
            setPSDLayout(psdLayout);
        } else {
            var psd = [{
                x: [-15,15],
                y: [-120,-120],
                mode: 'lines',
                name: 'L1',
                line: {color: colorWhite}
            },{
                x: [-15,15],
                y: [-120,-120],
                mode: 'lines',
                name: 'L2',
                line: {color: colorYellow}
            }];
            setPSDData(psd);  
            let psdLayout = layout_psd;
            psdLayout.title.text = 'PSD';
            setPSDLayout(psdLayout);
        } 
    }, [SNTime]);
    
    return (
        <div>
            <Plot data={data_psd as any} layout={layout_psd} useResizeHandler={true} style={{ width: '100%', height: '100%' }}/>
        </div>
    )
}
